var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 259,
    viewBox: "0 0 172 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3181 58.4521L46.4614 98.6505L23.0512 139.255L0 99.259L23.3181 58.4521Z",
    fill: "url(#paint0_linear_196_3378)",
    fillOpacity: 0.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.653 124.669C112.353 115.399 97.1338 115.656 92.4471 115.914C87.6877 121.814 81.7105 126.617 74.9241 129.994C68.1378 133.372 60.7022 135.245 53.1255 135.484C51.5547 135.484 50.0097 135.742 48.4389 135.742C43.7244 135.709 39.021 135.278 34.3789 134.454C34.3789 134.523 34.406 134.588 34.4543 134.636C34.5026 134.685 34.5681 134.712 34.6364 134.712C45.7095 162.942 65.8688 186.68 91.9321 202.179C99.5154 197.598 106.669 192.341 113.305 186.471C121.489 178.966 128.828 170.591 135.194 161.493C134.655 160.843 134.371 160.019 134.395 159.175C134.653 143.725 130.764 132.137 122.653 124.669Z",
    fill: "url(#paint1_linear_196_3378)",
    fillOpacity: 0.84
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1228 128.532C66.9253 127.502 77.8694 122.352 85.9552 112.824C75.0111 99.4334 81.526 79.8627 85.6977 70.0774L70.8394 71.6224C54.822 73.9112 39.3678 79.15 25.2604 87.073C25.2182 87.9394 25.305 88.8072 25.5179 89.6481C25.7754 94.0257 26.0329 98.6609 26.5479 103.039C27.4164 111.012 29.1431 118.869 31.6981 126.472C32.0586 126.461 32.4151 126.55 32.7281 126.729C39.3605 128.564 46.2715 129.175 53.1228 128.532Z",
    fill: "url(#paint2_linear_196_3378)",
    fillOpacity: 0.16
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0198 69.5625C90.6465 76.0002 81.4534 97.1159 91.934 108.961C97.6764 108.446 114.595 108.189 127.367 119.262C135.71 126.729 140.397 137.287 141.427 151.45C142.981 148.789 144.374 146.038 145.599 143.21C153.981 125.667 158.453 106.514 158.706 87.0731C138.855 76.1456 116.672 70.1407 94.0198 69.5625Z",
    fill: "url(#paint3_linear_196_3378)",
    fillOpacity: 0.84
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.456 99.8633L164.636 150.111L135.119 200.866L106.055 150.872L135.456 99.8633Z",
    fill: "url(#paint4_linear_196_3378)",
    fillOpacity: 0.16
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3378",
    x: 5.0494,
    y: 49.8768,
    width: 101.106,
    height: 99.1034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.1003
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3378",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3378",
    x: 85.8541,
    y: 79.6627,
    width: 98.9832,
    height: 141.404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.1003
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3378",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3378",
    x1: 23.1696,
    y1: 140.947,
    x2: -35.3193,
    y2: 77.0438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3378",
    x1: 84.6538,
    y1: 203.988,
    x2: 37.636,
    y2: 99.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3378",
    x1: 87.8774,
    y1: 122.157,
    x2: 16.1742,
    y2: 101.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3378",
    x1: 122.791,
    y1: 153.166,
    x2: 70.2213,
    y2: 65.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_196_3378",
    x1: 166.491,
    y1: 189.472,
    x2: 93.4033,
    y2: 177.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.c0d0244bd0ba78d3df5214f1ba394109.svg";
export { ForwardRef as ReactComponent };